import React from "react";
import { useSelector } from "react-redux";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import EditIcon from "@material-ui/icons/Edit";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import AgreementHTML from "./AgreementHTML.jsx";

import Button from "common/components/CustomButtons/Button.jsx";

// core components
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  ...regularFormsStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
    width: "100%",
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
  errorMessage: {
    color: "red",
  },
  label: {
    color: "black",
  },
  contactInfo: {
    margin: "20px",
  },
  formGroup: {
    alignItems: "center",
  },
  checkboxAndRadio: {
    margin: "20px",
  },
  buttonStyle: {
    margin: "20px",
  },
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
function daysuffix(day) {
  if (day === 1) {
    return "st";
  }
  if (day === 2) {
    return "nd";
  }
  if (day === 3) {
    return "rd";
  }
  return "th";
}

const Signature = (props) => {
  const ids = useSelector((state) => state.services.ids);

  const date = new Date();
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  function handleAgree() {
    props.goToSignaturePad();
  }

  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <EditIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {props.agreementDescription}
            </h4>
          </CardHeader>
          <CardBody>
            <AgreementHTML agreementType={props.agreementType} />
            <GridContainer align="center">
              <GridItem xs={12}>
                <h5>
                  <strong>
                    I have read, understood and agree to{" "}
                    {props.agreementDescription}
                  </strong>
                </h5>
                <br />
              </GridItem>

              <GridItem xs={12}>
                <Button
                  className={classes.buttonStyle}
                  color="primary"
                  onClick={handleAgree}
                >
                  CLICK HERE TO SIGN
                </Button>
              </GridItem>
              <GridItem xs={12}>
                <h5>
                  <strong>______________________</strong>
                </h5>
                <br />
              </GridItem>

              <GridItem xs={12}>
                <div className={classes.contactInfo}>
                  {props.type === "c" ? (
                    <>
                      <h5>Company Name: {props.name}</h5>
                      <h5>Authorized Signer: {props.name2}</h5>
                    </>
                  ) : (
                    <h5>Name: {props.name}</h5>
                  )}
                  <h5>Date: {`${month} ${day}${daysuffix(day)}, ${year}`}</h5>
                  <h5>Customer Number: {ids.user}</h5>
                  <h5>Electronically signed from identity: {ids.email}</h5>
                  <h5>IP address: {props.ip}</h5>
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(Signature);
